import { Controller, useForm } from "react-hook-form";
import _ from "@lodash";
import TextField from "@mui/material/TextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import React from "react";
import Box from "@mui/material/Box";
import SearchIcon from "@mui/icons-material/Search";
import BackIcon from "@mui/icons-material/Backspace";
import { FormControl, InputLabel, Select, IconButton, Card, MenuItem } from "@mui/material";

const defaultValues = { name: "", email: "", subject: "", message: "" };
const schema = yup.object().shape({
  name: yup.string().required("You must enter a name"),
  subject: yup.string().required("You must enter a subject"),
  message: yup.string().required("You must enter a message"),
  email: yup
    .string()
    .email("You must enter a valid email")
    .required("You must enter a email"),
});

function TransferFormFilter() {
  const { control, handleSubmit, watch, formState } = useForm({
    mode: "onChange",
    defaultValues,
    resolver: yupResolver(schema),
  });
  const { isValid, dirtyFields, errors } = formState;
  const form = watch();

  if (_.isEmpty(form)) {
    return null;
  }

  return (
    <>

      <Card variant="outlined" className="m-24 mb-0">
        <div className="flex content-between justify-start m-24">
          <div className="w-1/3 mr-16">
            <Controller
              control={control}
              name="subject"
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-16 w-full"
                  label="Search by Worksite Name"
                  placeholder="Search by Worksite Name"
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={!!errors.subject}
                  helperText={errors?.subject?.message}
                  
                />
              )}
            />
          </div>

          <div className="w-1/3  mr-16">
            <Controller
              control={control}
              name="subject"
              render={({ field }) => (
                <TextField
                  {...field}
                  className="mt-16 w-full"
                  label="Search by Participant Name (First + Last)"
                  placeholder="Search by Participant Name (First + Last)"
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={!!errors.subject}
                  helperText={errors?.subject?.message}
                  
                />
              )}
            />
          </div>

          <div className="w-1/3 mt-16 mr-16">
            <Box sx={{ minWidth: 120 }} >
              <FormControl fullWidth size="small">
                <InputLabel id="demo-simple-select-label">
                Select status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Select status"
                  
                >
                  <MenuItem value={"1"}>Approved</MenuItem>
                  <MenuItem value={"2"}>Submitted</MenuItem>
                  <MenuItem value={"2"}>Draft</MenuItem>
                  <MenuItem value={"2"}>Denied</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>

          <div className="mt-20">
            {" "}
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <SearchIcon />
            </IconButton>
          </div>
          <div className="mt-20  mr-1">
            {" "}
            <IconButton
              color="primary"
              aria-label="upload picture"
              component="label"
            >
              <BackIcon />
            </IconButton>
          </div>
        </div>
      </Card>

    </>
  );
}

export default TransferFormFilter;
